exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{margin:0;height:100%;width:100%;overflow:hidden}.main-menu-fab-container{margin:5px;float:left}.form-actions-container{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/App.css
// module id = 334
// module chunks = 0